<script lang="ts" setup>
const { loadLayout, layoutData } = useLayout()
await loadLayout()
</script>

<template>
  <div class="header-top">
    <div class="header-top__container">
      <ReviewComponent
        class="header-top__rating"
        :source="'trustpilot'"
      />

      <AppUsps
        v-if="layoutData?.headerUsps?.[0]?.Usp?.length"
        class="header-top__usps"
        :usps="layoutData.headerUsps[0]"
        horizontal
      />

      <div class="header-top__links">
        <HeaderLinks>
          <template #before>
            <StorePicker class="top-links__link" />
          </template>
        </HeaderLinks>
      </div>
    </div>
  </div>
</template>

<style>
@import url("~layers/components/Header/Top.css");
</style>
